import * as React from 'react';
import { connect } from 'dva';
import Chart from './components/Chart';
import StockChart from './components/Stock';
import MapChart from './components/Map';
import ABSNoContent from '../../components/ABSNoContent';
import ABSLoading from '../ABSLoading';
import ABSIconText from '../../components/ABSIconText';
import { ABSModal } from '../ABSModal';
import ABSIconTooltip from '../../components/ABSIconTooltip';
import Magnifier from './Magnifier';
import extensions from './extensions';
import commonUtils from '../../utils/commonUtils';
import classNames from 'classnames';
import './index.less';
import { PNGChartScale } from './utils';

interface IABSChartProps {
  type?: 'chart' | 'stock' | 'map'; // 默认chart
  config: any;
  title?: any;
  loading?: boolean;
  dispatch?: any;
  hideDownload?: boolean;
  hideEnlarge?: boolean;
  callback?: any;
  hideDataExport?: boolean;
  hidePngExport?: boolean;
  xAxisDisabled?: boolean;
  yAxisLeftDisabled?: boolean;
  hideMagnifierPngDownload?: boolean;
  hideRangeFilter?: boolean;
  hasLoadingDesc?: boolean;
  removeBorder?: boolean;
  hideMADesc?: boolean;
}
interface IIABSChartState {
  isSelectAll: boolean;
}

class ABSChart extends React.PureComponent<IABSChartProps, IIABSChartState> {
  static defaultProps = {
    type: 'chart'
  };
  reactChart;
  modal: ABSModal | null;
  constructor(props: any) {
    super(props);
    this.renderSelectButton = this.renderSelectButton.bind(this);
    this.state = { isSelectAll: true };
  }
  componentDidUpdate() {
    if (this.reactChart && this.props.type === 'stock') {
      this.reactChart.chart.xAxis[0].update();
    }
  }

  chartExcelDownload() {
    const { chartData, axisTitle, downloadList, title, xAxis, yAxis } = this.props.config;
    let payload;
    if (downloadList && downloadList.length) {
      payload = extensions.getSimpleChartDownloadData(downloadList, title, xAxis, yAxis);
    } else {
      payload = extensions.getChartDownloadData(chartData, axisTitle);
    }

    this.props.dispatch({
      type: 'global/getChartExport',
      payload
    });
  }

  getPngChartDownloadData(title: any) {
    // const { type } = this.props;
    // let svg = chart.chart.getSVG(options);
    // if (type === 'stock') {
    //   svg = svg.replace('范围：', '');
    // }
    return {
      // file_name: title,
      filename: title,
      type: 'image/png',
      // svg: svg,
      scale: PNGChartScale,
      width: 1200,
      // height: PNGChartHeight * PNGChartScale, 无效了
      // sourceHeight,
      // sourceWidth
    };
  }

  chartPngDownload(isBgWhite: boolean) {
    const { config, type } = this.props;
    const { chartData, title } = this.props.config;
    const titleNew = title && title.text ? title.text : chartData.title;
    const options = extensions.getSVGConfig(config, isBgWhite, type);
    const payload = this.getPngChartDownloadData(titleNew);
    this.reactChart.chart.exportChartLocal(payload, options);
    // this.props.dispatch({
    //   type: 'global/getChartPng',
    //   payload
    // });
  }

  renderDesc(showMADesc?: boolean) {
    if (!showMADesc) {
      return null;
    }
    return <div className="abs-chart-stock-desc" />;
  }

  renderDownload(hideDownload?: boolean) {
    if (hideDownload) {
      return null;
    }
    return (
      <div className="abs-chart-excel-download">
        <ABSIconTooltip
          text=""
          type="cloud-download"
          width={113}
          placement={'bottomLeft'}
          details={this.renderDownLoadDetails()}
          overlayClassName="tooltip-container"
        />
      </div>
    );
  }

  chartDetailDownload() {
    const { chartDetailUrl } = this.props.config;
    this.props.dispatch({
      type: 'global/getChartDetailExport',
      payload: chartDetailUrl
    });
  }

  // 是否显示详细数据菜单
  renderDetailInfo() {
    const { chartDetailUrl } = this.props.config;
    if (!chartDetailUrl) {
      return null;
    }
    return <ABSIconText className="download-container-img-excel" icon="xls" text="详细数据" onClick={() => this.chartDetailDownload()} />;
  }

  // 是否显示详细数据菜单
  renderPngExport() {
    const { hidePngExport } = this.props;

    if (hidePngExport) {
      return null;
    }
    return (
      <>
        <ABSIconText className="download-container-img-png" icon="pic" text="黑底图片" onClick={() => this.chartPngDownload(false)} />
        <ABSIconText className="download-container-img-png" icon="pic" text="白底图片" onClick={() => this.chartPngDownload(true)} />
      </>
    );
  }

  renderDownLoadDetails() {
    const { hideDataExport } = this.props;
    return (
      <div className="download-container">
        {!hideDataExport ? (
          <ABSIconText className="download-container-img-excel" icon="xls" text="作图数据" onClick={() => this.chartExcelDownload()} />
        ) : null}
        {this.renderPngExport()}
      </div>
    );
  }

  renderEnlarge(config: any, hideEnlarge?: boolean) {
    if (hideEnlarge || !config) {
      return null;
    }
    return (
      <div className="chart-magnifier-icon">
        <ABSIconText icon="magnifier" text="" onClick={() => this.onMganifierChart(config.title.text)} />
      </div>
    );
  }

  renderSelectButton() {
    let refs: any = this.reactChart;
    if (refs) {
      let result = refs.chart;
      if (result.series.length > 0) {
        if (this.state.isSelectAll) {
          result.series.forEach(item => {
            item.hide();
          });
        } else {
          result.series.forEach(item => {
            item.show();
          });
        }
        this.setState({ isSelectAll: !this.state.isSelectAll });
      }
    }
  }

  onMganifierChart(title: string) {
    if (this.modal) {
      this.modal.show(true);
      const params = {
        title_str: title,
        url: window.location.href
      };
      this.props.dispatch({
        type: 'global/getChartZoom',
        payload: params
      });
    }
  }

  render() {
    const {
      type,
      config,
      callback,
      loading,
      hideDownload,
      hasLoadingDesc,
      hideEnlarge,
      xAxisDisabled,
      yAxisLeftDisabled,
      hideMagnifierPngDownload,
      hideRangeFilter,
      removeBorder
    } = this.props;

    if (config == null || config === undefined) {
      return null;
    }

    let chartClass: string = 'abs-chart';
    const { showMADesc } = config;
    let HighChart: any = Chart;
    if (type === 'stock') {
      HighChart = StockChart;
      chartClass = classNames('abs-chart', { 'abs-hide-range-selector': showMADesc });
    }
    if (type === 'map') {
      HighChart = MapChart;
    }

    if (loading) {
      return (
        <div className="abs-chart-loading">
          <ABSLoading />
          {/* 因为数据过多，IE加载有问题，loading时添加文字说明 */}
          {hasLoadingDesc && commonUtils.getIEVersion() > 0 ? <div className="abs-loading-desc">建议使用Chrome或Firefox</div> : null}
        </div>
      );
    }
    if (removeBorder) {
      commonUtils.setValue(config, 'chart.borderWidth', Number(!removeBorder));
    }

    const enLargeConfig = extensions.getEnLargeConfig(commonUtils.deep(config));

    const afterRender2 = chart => {
      // 处理数据绘图坐标轴最大值，最小值问题
      if (config.xAxisType && config.yAxisType && config.series && config.series.length > 0) {
        callback(chart, config.xAxisType, config.yAxisType);
      }
      // 强制修改rangeSelector-input的类型（date -> text）
      // setTimeout(function() {
      //   const doms = document.getElementsByClassName('highcharts-range-selector');
      //   for (var i = 0; i < doms.length; i++) {
      //     doms[i].setAttribute('type', 'text');
      //   }
      // }, 0);
    };
    // const modalChart = <ReactHighcharts config={enLargeConfig} />;
    const modalChart = (
      <Magnifier
        type={type}
        config={enLargeConfig}
        xAxisDisabled={xAxisDisabled}
        yAxisLeftDisabled={yAxisLeftDisabled}
        hideMagnifierPngDownload={hideMagnifierPngDownload}
        hideRangeFilter={hideRangeFilter}
      />
    );

    const chartDiv = (
      <div className={chartClass} style={{ height: config.height }}>
        {this.renderDesc(showMADesc)}
        {this.renderDownload(hideDownload)}
        {this.renderEnlarge(enLargeConfig, hideEnlarge)}
        <HighChart
          options={config}
          refs={ref => {
            this.reactChart = ref;
          }}
          callback={afterRender2}
        />
        <ABSModal destroyOnClose={true} content={modalChart} width={900} footer={null} ref={view => (this.modal = view)} wrapClassName="enlarge-container" />
        {/* <button onClick={this.renderSelectButton} className="select-all">{this.state.isSelectAll ? 'yes' : 'no'}</button> */}
      </div>
    );
    const noDataClass = classNames('no-chart-data', { 'abs-remove-border': removeBorder }, {'abs-no-data-has-title': config.title});
    if (!config.series || config.series.length === 0 || (config.series.length === 1 && config.series[0].data.length === 0)) {
      if (config.title) {
        return (
          <div className={noDataClass}>
            <p className="abs-chart-title">{config.title.text}</p>
            <ABSNoContent />
          </div>
        );
      } else {
        return (
          <div className={noDataClass}>
            <ABSNoContent />
          </div>
        );
      }
    }
    return <div style={{ width: '100%' }}>{chartDiv}</div>;
  }
}
export default connect()(ABSChart);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/index.tsx